/**
 * The file enables `@/store/index.js` to import all vuex modules
 * in a one-shot manner. There should not be any reason to edit this file.
 */

// get all .js files in this folder and sub-folder(s)
const files = require.context(".", true, /\.js$/);
const modules = {};

files.keys().forEach(key => {
  // ignore the current file
  if (key === "./index.js") return;

  // extract the file name from path
  let fileName = key.replace(/(\.\/|\.js)/g, "");

  if (fileName.indexOf("/") > -1)
    fileName = fileName.substr(fileName.lastIndexOf("/") + 1);

  modules[fileName] = files(key).default;
});

export default modules;



// WEBPACK FOOTER //
// ./src/store/modules/index.js